import React from "react";
import {Redirect, Route} from "react-router";


export const PrivateRoute = ({ component: Component, permitted, redirectTo='/error/403/', ...rest }) => {
    return(
        <Route
            {...rest}
            render={(props) => permitted === true
                ? <Component {...rest} />
                : <Redirect to={{ pathname: redirectTo, state: { from: props.location } }} />}
        />
    )
};